import { SET_PAGE_STATUS, CMS_MISSING } from './constants'
import { isEmpty } from 'lodash'

const initialState = {
  status: CMS_MISSING,
  cmsdata: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGE_STATUS:
      if (!isEmpty(window.ngwVWapp)) {
        const json = window.ngwVWapp[0]
        return { ...state, status: action.payload, cmsdata: json }
      }
      return { ...state, status: CMS_MISSING }
    default:
      return state
  }
}
